export type IProductType = 'ISA' | 'ProviPay' | 'Allowance'

const payProductTypes = {
  pay: 'ProviPay',
  'pay-staging': 'ProviPay',
  'pay-v3-dev': 'ProviPay',
}

const isaProductTypes = {
  isa: 'ISA',
  'isa-staging': 'ISA',
  'isa-dev': 'ISA',
}

const allowanceProductTypes = {
  mesada: 'Allowance',
  'mesada-staging': 'Allowance',
  'mesada-dev': 'Allowance',
}

export const productTypes = {
  ...payProductTypes,
  ...isaProductTypes,
  ...allowanceProductTypes,
}
